import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';
import { PayOrderInfo } from './payOrder';

export const DeclarePayOrder = () => gql`
  mutation DeclarePayOrder($params: DeclarePayOrderParams!) {
    declarePayOrder(params: $params) {
      id
      uuid
      status
      orderGroupId
      address {
        id
        name
        street
        streetNumber
        commune
      }
    }
  }
`;

export type DeclarePayOrderMutationParams = ResolverParams<{
  amount: number;
  orderUuid: string;
  orders: PayOrderInfo[];
  chargeDeliveryCost: boolean;
  paymentType?: string;
  sendEmail?: boolean;
  useCredits?: boolean;
  insuranceId?: number;
}>;

export type DeclarePayOrderMutationResponse = {
  declarePayOrder: Order;
};
